export default __webpack_public_path__ + "static/media/O-066.075e2226.png";